import {
  documentToReactComponents,
  Options,
} from "@contentful/rich-text-react-renderer";
import {
  Block,
  BLOCKS,
  Document,
  Inline,
  INLINES,
} from "@contentful/rich-text-types";
import { Link } from "@yardzen/ui/components/link";
import { P } from "@yardzen/ui/components/p";
import { cn } from "@yardzen/ui/lib/utils";
import { forwardRef, ReactNode } from "react";

interface RichTextProps {
  content: Document;
  className?: string;
  ulClassName?: string;
  aClassName?: string;
  pClassName?: string;
  pNoSpacing?: boolean;
}

const RichText = forwardRef<HTMLDivElement, RichTextProps>(
  (
    { content, className, ulClassName, aClassName, pClassName, pNoSpacing },
    ref,
  ) => {
    const options: Options = {
      renderNode: {
        [BLOCKS.UL_LIST]: (node: Block | Inline, children: ReactNode) => {
          return (
            <ul className={cn("ml-4 list-disc", ulClassName)}>{children}</ul>
          );
        },
        [BLOCKS.PARAGRAPH]: (node: Block | Inline, children: ReactNode) => {
          return (
            <P noSpacing={pNoSpacing} className={cn("mb-4", pClassName)}>
              {children}
            </P>
          );
        },
        hyperlink: (node) => {
          if (node.nodeType !== INLINES.HYPERLINK) {
            return;
          }
          const content = node.content[0];
          if (content.nodeType !== "text") {
            return;
          }
          return (
            <Link href={node.data.uri} className={cn("underline", aClassName)}>
              {content.value}
            </Link>
          );
        },
      },
    };

    return (
      <div ref={ref} className={cn(className)}>
        {documentToReactComponents(content, options)}
      </div>
    );
  },
);

RichText.displayName = "RichText";

export { RichText };
